import React, { useEffect, useState } from "react";
import "../brandStore/cards/cards.css";
import Style from "../theme6/style/subcategory.module.scss";
import Cards from "./cards";
import BackArrow from "../../../assets/svg/BackArrow";
import QuizWallicon from "../../../assets/svg/QuizWallicon";
import { useNavigate } from "react-router-dom";
import BottomBar from "../theme6/component/BottomBar";
import authAxios from "../../../config/authAxios";

const BrandStore = () => {
  const navigate = useNavigate()
    window.scrollTo(0, 0);


  const [giftCard, setGiftCard] = useState([])
  const [wallet, setWallet] = useState({})
  const fetchCards = async (e) => {
    try {
      const response = await authAxios.get(`/users/api/giftCards/3`);

      setGiftCard([...response?.data?.data])
      setWallet(response?.data?.userWallet)
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    fetchCards()
  }, [])


  return (
    <>
      <div className={"box_container"}>
        <div className={"store_box_container_top"}>
          <div onClick={() => navigate(-1)}>
            <BackArrow />
          </div>
          <QuizWallicon width={143} height={31} />
        </div>
        <div className={"store_box_container"}>
          <h3 className={"st_text1"}>Store</h3>

          <div className={"banner_sub_cards"}>
            {giftCard?.length > 0 && giftCard?.map((e) => {
              return (<React.Fragment key={e?._id}>
                <Cards data={e} wallet={wallet} />
              </React.Fragment>)
            })}

          </div>
        </div>
        <BottomBar />

      </div>
    </>
  );
};

export default BrandStore;
